module.exports = __webpack_public_path__ + "static/media/023.0635a5d6.jpg";